import axios from "axios";

// Get new question suggestions from chat assistant
// params: { userId: number, language: string }
const post = ({ userId, language }) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/ai/user_api/v1/get_chat_assistant_question", {
        user_id: userId,
        language: language,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data ?? error));
  });
};

const getChatAssistantQuestion = {
  post,
};

export default getChatAssistantQuestion;
